import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext } from 'react';
import 'prop-types';
import ThemeContext from '../../ThemeProvider/context.js';
import '../../../utils/responsivePropTypes.js';
import Box from '../Box/Box.js';

const Container = ({
  size,
  children,
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const sizes = {
    sm: `${theme.breakpoints.tablet.minWidth}px`,
    md: `${theme.breakpoints.laptop.minWidth}px`,
    lg: `${theme.breakpoints.desktop.minWidth}px`,
    xl: `${theme.breakpoints.hd.minWidth}px`
  };
  const width = sizes[size] || size;
  return /*#__PURE__*/React.createElement(Box, _extends({
    maxWidth: width
  }, props), children);
};
Container.defaultProps = {
  margin: [0, 'auto']
};

export { Container as default };
